import { track } from '@fff-web/fff-analytics';
import { getQueryParam } from '../../MyAccount/utils/url';

const REACTIVATION_COMPLETED_EVENT = 'Reactivation Completed';
const REACTIVATION_COMPLETED_EVENT_TYPE = 'Expired Member';
const REACTIVATION_COMPLETED_TYPE = 'Expired';

const sendReactivateSegmentEventAfterResponse = (status, ctaName) => track({
  trackName: REACTIVATION_COMPLETED_EVENT,
  properties: {
    cta_name: ctaName,
    type: REACTIVATION_COMPLETED_EVENT_TYPE,
    experience: getQueryParam('referrer'),
    reactivation_type: REACTIVATION_COMPLETED_TYPE,
    status,
  },
});

export default sendReactivateSegmentEventAfterResponse;
